import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import { ReactComponent as IconStar } from '../../assets/icons/rating-star-gold.svg';
import { useUserReviews } from '../../hooks/queries/useUserReviews';
import css from './UserReviewBadge.module.css';

const UserReviewBadge = ({ userId, className }) => {
  const { data: reviewsData, isLoading: isFetchingReviews } = useUserReviews({
    userId,
  });

  const reviews = reviewsData?.reviews || [];
  const reviewsRatingAvg = reviewsData?.reviewsRatingAvg || 0;

  if (isFetchingReviews) {
    return (
      <div className={className || css.wrapper}>
        <div className={css.loaderWrapper}>
          <Skeleton borderRadius={4} height={24} width="100%" />
        </div>
      </div>
    );
  }

  if (reviews.length === 0) {
    return null;
  }

  return (
    <div className={className || css.wrapper}>
      <IconStar className={css.starIcon} />
      <span className={css.avg}>{reviewsRatingAvg}</span>
      <span className={css.total}>
        (
        <FormattedMessage
          id="UserCard.reviews"
          values={{
            count: reviews.length,
          }}
        />
        )
      </span>
    </div>
  );
};

UserReviewBadge.defaultProps = {
  className: null,
};

UserReviewBadge.propTypes = {
  userId: string.isRequired,
  className: string,
};

export default UserReviewBadge;
